var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"primary","html-type":"submit"}},[_vm._t("text",[_vm._v("Сохранить")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }